import {
  Box,
  Button,
  Grid,
  Typography,
  Avatar,
  Popover,
  MenuItem,
  Modal,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdChevronLeft } from "react-icons/md";
import { IoCarOutline } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import { useMutation, useQuery } from "@apollo/client";
import { REFUND_CUSTOMER_ORDER } from "../../Utils/Mutation";
import Loader from "../Common/Loader";
import { useSnackbarHook } from "../../hooks/useSnackbarHook";
import CloseIcon from "@mui/icons-material/Close";
import FindDriverModal from "./AssignDriver";

const steps = [
  {
    label: "Order is ready",
    description: ``,
  },
  {
    label: "Assign driver",
    description: ``,
  },
  {
    label: "Picked Up",
    description: ``,
  },
  {
    label: "Delivered",
    description: ``,
  },
  {
    label: "Review",
    description: ``,
  },
];

const DeliveryDetails = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [modalOpen, setModalOpen] = React.useState(false);

  const { id } = useParams(); // use to assign driver later

  const storedData = JSON.parse(localStorage.getItem("selectedDeliveryItem"));

  const [buttonStatus, setButtonStatus] = useState("Refund Order");

  const { handleClick: handleAlert } = useSnackbarHook();

  const singleOrder = storedData;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const idPopover = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (singleOrder?.status === "Delivered") {
      setActiveStep(4);
    } else if (singleOrder?.status === "Order is ready") {
      setActiveStep(1);
    } else if (singleOrder?.status === "Assign driver") {
      setActiveStep(2);
    } else if (singleOrder?.status === "Picked Up") {
      setActiveStep(3);
    } else if (singleOrder?.status === "Review") {
      setActiveStep(5);
    } else {
      setActiveStep(0);
    }
  }, [singleOrder]);

  const [refundOrder] = useMutation(REFUND_CUSTOMER_ORDER);
  const [isLoading, setIsLoading] = useState(false);

  const handleRefundOrder = async () => {
    setIsLoading(true);
    await refundOrder({
      variables: {
        itemId: id,
      },
    })
      .then((res) => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);

        handleAlert(`${err?.message}`, "error");
      });
  };
  return (
    <>
      {isLoading && <Loader />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link to="/dashboard/delivery">
          <Button
            sx={{ bgcolor: "#fff", color: "#666" }}
            startIcon={<MdChevronLeft />}
          >
            Delivery Details
          </Button>
        </Link>
        <Box>
          <Button
            aria-describedby={idPopover}
            variant="contained"
            onClick={handleClick}
            sx={{ bgcolor: "#5c3069", color: "#fff", ml: 3 }}
            startIcon={<IoCarOutline />}
          >
            Assign Driver
          </Button>
        </Box>
      </Box>

      <Grid container sx={{ mt: 2 }} spacing={1}>
        <Grid item lg={8}>
          <Box sx={{ bgcolor: "#fff", p: 2 }}>
            <Typography
              sx={{ color: "#4d4d4d", fontWeight: 500, fontSize: "12px" }}
            >
              ID: {singleOrder?._id}
            </Typography>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", columnGap: 3 }}>
                <Avatar
                  src={singleOrder?.product?.images[0]}
                  variant="square"
                  sx={{ width: "88px", height: "88px" }}
                />
                <Box>
                  <Typography sx={{ fontWeight: 500, fontSize: "16px" }}>
                    {singleOrder?.product?.name}
                  </Typography>
                  <Box sx={{ display: "flex", columnGap: 5, mt: 5 }}>
                    <Typography sx={{ fontWeight: 400, fontSize: "14px" }}>
                      QTY: {singleOrder?.orderItem?.quantity}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box
                  sx={{
                    px: 3,
                    bgcolor: "#f2f2f2",
                    borderRadius: 10,
                    py: 0.5,
                    fontSize: "12px",
                    ...(singleOrder?.status === "Canceled" && {
                      color: "#FF3347",
                    }),
                  }}
                >
                  {singleOrder?.status}
                </Box>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    mt: 5,
                    textAlign: "right",
                    color: "#fff",
                  }}
                >
                  .{singleOrder?.amountPaid?.toLocaleString()}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ bgcolor: "#fff", p: 2, mt: 0.2 }}>
            <Typography sx={{ fontWeight: 500 }}>Pickup Information</Typography>

            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography>Name:</Typography>
                <Typography
                  sx={{
                    color: "#101010",
                    fontWeight: 500,
                  }}
                >
                  {`${singleOrder?.pickupAddress?.firstName} ${singleOrder?.pickupAddress?.lastName}`}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                }}
              >
                <Typography>Address:</Typography>
                <Typography sx={{ color: "#101010", fontWeight: 500 }}>
                  {singleOrder?.pickupAddress?.addressOne}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                }}
              >
                <Typography>Phone:</Typography>
                <Typography sx={{ color: "#101010", fontWeight: 500 }}>
                  {singleOrder?.pickupAddress?.phone}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ bgcolor: "#fff", p: 2, mt: 0.2 }}>
            <Typography sx={{ fontWeight: 500 }}>
              Delivery Information
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography>Name:</Typography>
                <Typography
                  sx={{
                    color: "#101010",
                    fontWeight: 500,
                  }}
                >
                  {`${singleOrder?.shippingAddress?.firstName} ${singleOrder?.shippingAddress?.lastName}`}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                }}
              >
                <Typography>Address:</Typography>
                <Typography sx={{ color: "#101010", fontWeight: 500 }}>
                  {singleOrder?.shippingAddress?.addressOne}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                }}
              >
                <Typography>Phone:</Typography>
                <Typography sx={{ color: "#101010", fontWeight: 500 }}>
                  {singleOrder?.shippingAddress?.phone}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ bgcolor: "#fff", p: 2, mt: 0.2 }}>
            <Typography sx={{ fontWeight: 500 }}>Delivery Payment</Typography>

            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography>Amount:</Typography>
                <Typography
                  sx={{
                    color: "#101010",

                    fontWeight: 500,
                  }}
                >
                  ${singleOrder?.orderItem?.amountPaid?.toLocaleString()}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item lg={4}>
          <Box sx={{ p: 2, bgcolor: "#FFF" }}>
            <Typography>Status</Typography>
            <Box>
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label} sx={{ fontFamily: "Lato" }}>
                    <StepLabel

                    // StepIconProps={{
                    // }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Lato",
                          color: "#333",
                          fontSize: "14px",
                          fontWeight: 500,
                          ...(singleOrder?.status === "Canceled" && {
                            color: "#FF3347",
                            opacity: 0.3,
                          }),
                        }}
                      >
                        {" "}
                        {step.label}
                      </Typography>
                    </StepLabel>
                    <StepContent>
                      <Typography
                        sx={{
                          fontFamily: "Lato",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        {step.description}
                      </Typography>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <FindDriverModal
        modalOpen={modalOpen}
        setModalOpen={() => setModalOpen(false)}
      />

      {/* <Popover
        id={idPopover}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 1 }}>
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setButtonStatus("Release Funds");
            }}
          >
            Release Funds
          </MenuItem>
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setButtonStatus("Refund Order");
            }}
          >
            Refund Order
          </MenuItem>
        </Box>
      </Popover> */}
    </>
  );
};

export default DeliveryDetails;

function formatDate(dateString) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(dateString).toLocaleDateString("en-GB", options);
}

function formatTime(isoString) {
  const date = new Date(isoString);
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // to display AM/PM
  });
  return formattedTime;
}
